import type { Modifier } from '@dnd-kit/core';
import { getEventCoordinates } from '@dnd-kit/utilities';

function hasPointerCoordinates(event: globalThis.Event): boolean {
  return (
    event instanceof globalThis.MouseEvent ||
    event instanceof globalThis.TouchEvent ||
    event instanceof globalThis.PointerEvent
  );
}

/**
 * Centers the drag overlay on the pointer when picked up.
 * Matches @dnd-kit/modifiers snapCenterToCursor (uses activeNodeRect + transform delta).
 */
export const snapCenterToCursor: Modifier = ({
  activatorEvent,
  activeNodeRect,
  transform,
}) => {
  if (!activeNodeRect || !activatorEvent || !hasPointerCoordinates(activatorEvent)) {
    return transform;
  }

  const activatorCoordinates = getEventCoordinates(activatorEvent);
  const offsetX = activatorCoordinates.x - activeNodeRect.left;
  const offsetY = activatorCoordinates.y - activeNodeRect.top;

  return {
    ...transform,
    x: transform.x + offsetX - activeNodeRect.width / 2,
    y: transform.y + offsetY - activeNodeRect.height / 2,
  };
};
